import { useState, useEffect } from "react";
import food1 from './../assets/images/Food/food1.webp'
import food2 from './../assets/images/Food/food2.webp'
import food3 from './../assets/images/Food/food3.webp'
import food4 from './../assets/images/Food/food4.webp'
import food5 from './../assets/images/Food/food5.webp'
import food6 from './../assets/images/Food/food6.jpeg'
import food7 from './../assets/images/Food/food7.jpeg'
import food8 from './../assets/images/Food/food8.jpeg'
import food9 from './../assets/images/Food/food9.jpeg'
import food10 from './../assets/images/Food/food10.jpeg'
import food11 from './../assets/images/Food/food11.jpeg'
import food12 from './../assets/images/Food/food12.jpeg'
import food13 from './../assets/images/Food/food13.jpeg'
import food14 from './../assets/images/Food/food14.jpeg'
import food15 from './../assets/images/Food/food15.jpeg'
import video1 from './../assets/videos/food.mp4'

// --------------------------------------------------
// MOVE ARRAYS OUTSIDE COMPONENT → Fixes dependency warnings
// --------------------------------------------------
const images1 = [food1, food3, food5, food7, food9, food11, food13, food15];
const images4 = [food2, food4, food6, food8, food10, food12, food14];

const Food = () => {
  const [idx1, setIdx1] = useState(0);
  const [idx4, setIdx4] = useState(0);

  const [flip1, setFlip1] = useState(false);
  const [flip4, setFlip4] = useState(false);

  const randomTime = () => 2500 + Math.random() * 2000;

  // --------------------------------------------------
  // IMAGE 1 flip left → right
  // --------------------------------------------------
  useEffect(() => {
    const start = () => {
      setFlip1(true);
      setTimeout(() => setIdx1(prev => (prev + 1) % images1.length), 300);
      setTimeout(() => setFlip1(false), 650);
    };

    const timer = setTimeout(start, randomTime());
    return () => clearTimeout(timer);
  }, [idx1]);

  // --------------------------------------------------
  // IMAGE 4 flip right → left
  // --------------------------------------------------
  useEffect(() => {
    const start = () => {
      setFlip4(true);
      setTimeout(() => setIdx4(prev => (prev + 1) % images4.length), 300);
      setTimeout(() => setFlip4(false), 650);
    };

    const timer = setTimeout(start, randomTime());
    return () => clearTimeout(timer);
  }, [idx4]);

  return (
    <div className="max-w-[90%] m-auto px-4 grid gap-6">
      <div className="grid grid-cols-2 grid-rows-6 h-[40vh] lg:h-[50vh] md:h-[40vh] gap-4">

        {/* IMAGE 1 — flips left → right */}
        <img
          src={images1[idx1]}
          alt=""
          className={`
            row-span-3 object-cover w-full h-full rounded-lg shadow-md
            transform flip-forward-left
            ${flip1 ? "flip" : ""}
          `}
        />

        {/* VIDEO */}
        <video
          className="row-span-6 object-cover w-full h-full rounded-lg shadow-md"
          src={video1}
          autoPlay loop muted playsInline
        />

        {/* IMAGE 4 — flips right → left */}
        <img
          src={images4[idx4]}
          alt=""
          className={`
            row-span-3 object-cover w-full h-full rounded-lg shadow-md
            transform flip-forward-right
            ${flip4 ? "flip" : ""}
          `}
        />

      </div>
    </div>
  );
};

export default Food;